import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  mainGrid: {
    display: "flex",
    justifyContent: "center",
    marginTop: 10,
  },
  regPaper: {
    textAlign: "center",
    padding: 20,
    width: "100%",
  },
  autoComplete: {
    width: "220px",
  },
  submitBox: {
    display: "flex",
    justifyContent: "flex-end",
  },
  submitButton: {
    marginRight: "2%",
    marginTop: "2%",
  },
  tableGrid: {
    display: "flex",
    justifyContent: "center",
    marginTop: 2,
  },
  tableContainer: {
    maxWidth: "98%",
    marginTop: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  mainButton: {
    border: "none",
    outline: "none",
    fontSize: "20px",
    padding: "10px 15px",
    margin: "10px 20px 0 0",
    borderRadius: "3px",
    background: "#0174ef",
    color: "white",
    cursor: "pointer",
  },
  createDelivery: {
             //width: "1142px",
    //   height: "117px",
    //margin: "24px",
    padding: "24px 300px 24px 24px",
    borderRadius: "7px",
    backgroundColor: "#fff",
  },
  buildTestDeliveryDate: {
    //         width: "1142px",
    //   height: "117px",
    //margin: "24px 24px 19px",
    padding: "24px 22px 22px 23px",
    borderRadius: "7px",
    backgroundColor: "#fff",
  },
  buildTestItemProperties: {
    // width: "1142px",
    // height: "244px",
    //margin: "19px 24px 16px",
    padding: "24px 22px 24px 24px",
    borderRadius: "7px",
    backgroundColor: "#fff",
  },
  noteMsg: {
    //width: "562px",
    height: "17px",
    //margin: "16px 443px 9px 25px",
    fontFamily: "HelveticaNeue",
    fontSize: "14px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    //textAlign: "center",
    color: "#a30f0f",
  },
  addDeliveryBtn: {
    width: "136px",
    height: "38px",
    margin: "9px 24px 254px 443px",
    padding: "7px 24px 7px 29px",
    borderRadius: "4px",
    backgroundColor: "#3354b5",
  },
  tabs: {
    "& .css-1l5yae9-MuiTabs-indicator": {
      display: "none",
    },
    "& .css-1y7uyup-MuiButtonBase-root-MuiTab-root.Mui-selected": {
      color: "white",
      backgroundColor: "#3f51b5",
      border: "1px solid blue",
    },
    "& .css-1y7uyup-MuiButtonBase-root-MuiTab-root": {
      border: "1px solid blue",
    },
  },
}));
